import { setTimeout } from 'timers/promises';
import { TimeoutError } from '../errors';
import { OVERRIDE_TIMEOUTS } from '../commons/config';

export function isPromise(obj: any): obj is Promise<any> {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function' && typeof obj.catch === 'function';
}

/** @param time in ms */
export function delay(time: number) {
    return setTimeout<void>(time);
}


export function promiseAbort<T>(promise: T | PromiseLike<T>, abortSignal: AbortSignal) {
    const abortPromise = new Promise<never>((_, rej) => {
        abortSignal.onabort = () => {
            rej(abortSignal.reason);
        };
    });
    return Promise.race([
        promise,
        abortPromise,
    ]);
}

let warnedAboutDebugger = false;
export function promiseTimeout<T>(promise: T | PromiseLike<T>, timeout: number, errMsg = 'Timeout Error') {
    if (OVERRIDE_TIMEOUTS && !warnedAboutDebugger) {
        warnedAboutDebugger = true;
        // eslint-disable-next-line no-console
        console.log('Debugger connected - timeouts were overridden to 10 minutes to improve debugging');
    }
    const timeoutErr = new TimeoutError(errMsg);
    timeout = OVERRIDE_TIMEOUTS ? Number(OVERRIDE_TIMEOUTS) || 600_000 : timeout;
    return Promise.race([
        promise,
        delay(timeout).then(() => { throw timeoutErr; }),
    ]);
}

let pLimit: typeof import('p-limit')['default'];
export async function promiseMap<T, U>(arr: ArrayLike<T> | Iterable<T>, handler: (item: T, index: number) => PromiseLike<U>, { concurrency }: { concurrency?: number } = {}) {
    if (concurrency) {
        pLimit ||= (await import('p-limit')).default;
        const limit = pLimit(concurrency);
        return await Promise.all(Array.from(arr, (item, index) => limit(() => handler(item, index))));
    }
    return await Promise.all(Array.from(arr, handler));
}

export function promiseFromCallback<ErrT, T>(resolver: (callback: (err: ErrT, result?: T) => void) => void) {
    return new Promise<T | undefined>((resolve, reject) => {
        resolver((err, result) => {
            if (err) {
                return reject(err);
            }
            return resolve(result);
        });
    });
}
